var ExistingAddressListController = /** @class */ (function () {
    /*@ngInject*/
    function ExistingAddressListController($scope, $log, params, $mdDialog) {
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$log = $log;
        console.log('In ExistingAddressListController, params -> ', params);
        this.loggedInUser = params.loggedInUser;
    }
    return ExistingAddressListController;
}());
export default ExistingAddressListController;
;
//# sourceMappingURL=existing-address-list.controller.js.map